import React, { Component } from 'react';
import { View, Text, Image } from 'react-native';
import Loading from '@qnpm/q-loading';

import styles from './style';

interface SpinInterface {
    loading?: boolean;
    onClose?: () => void;
}
class Spin extends Component<SpinInterface> {
    public render() {
        const { loading, onClose } = this.props;
        if (!loading) {
            return null;
        }

        return (
            <View style={styles.container}>
                <Loading
                    type="circle"
                    showClose={true}
                    onClose={onClose}
                />
            </View>
        );
    }
}

export default Spin;
